<script setup lang="ts">
import type { PressRecord } from '~/types/datocms'
import { AppTheme } from '~/types'

const props = defineProps<{
  data: PressRecord
}>()

const store = useAppStore()
const { formatShort } = useDate(props.data.published ? new Date(props.data.published) : undefined)
</script>

<template>
  <div class="mx-auto my-12 max-w-2xl px-4 lg:my-48">
    <div class="mb-2 text-sm lg:mb-12">FROM THE PRESS</div>
    <Image
      v-if="data.media"
      :src="data.media?.url"
      :srcset="data.media?.responsiveImage ? data.media?.responsiveImage?.webpSrcSet : undefined"
      :width="data.media?.width ?? 400"
      :height="data.media?.height ?? 300"
      :alt="data.media?.alt ?? ''"
      data-swiper-parallax="-200"
      class="mb-4 will-change-transform lg:mb-6"
      :class="{ 'mix-blend-difference invert': store.theme === AppTheme.DARK }"
    />
    <div
      v-if="data.published"
      class="transform-gpu text-lg will-change-transform"
      data-swiper-parallax="-300"
    >
      {{ formatShort }}
    </div>
    <div
      v-if="data.title"
      class="mb-4 mt-6 transform-gpu text-2xl font-bold will-change-transform lg:mb-6 lg:mt-9"
      data-swiper-parallax="-400"
    >
      {{ data.title }}
    </div>
    <div
      v-if="data.excerpt"
      class="mb-8 transform-gpu text-2xl will-change-transform lg:mb-9"
      data-swiper-parallax="-500"
    >
      {{ data.excerpt }}
    </div>
    <Button
      label="READ ARTICLE"
      :to="data.url"
      variant="outline"
      target="_blank"
      data-swiper-parallax="-600"
      :blend-mode="store.theme === AppTheme.DARK"
    />
  </div>
</template>
